import {SlideShowModel} from './models';
import {SlideShowState} from './classroom/models';

function initialState(model: SlideShowModel): SlideShowState {
  return {currentSlide: 0};
}

class SlideshowUtilsClass {
  readonly initialState = initialState;
}

export const slideshowUtils = new SlideshowUtilsClass();
